function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.717.117a2.25 2.25 0 00-1.433 0L1.55 5.401A2.276 2.276 0 000 7.562v16.409c0 2.177.904 4.18 2.278 5.97 1.375 1.788 3.233 3.378 5.179 4.737 3.89 2.717 8.177 4.538 9.782 5.175a2.039 2.039 0 001.522 0c1.605-.637 5.892-2.458 9.783-5.175 1.946-1.358 3.804-2.949 5.179-4.737C35.097 28.15 36 26.148 36 23.97V7.562c0-.983-.625-1.85-1.55-2.161L18.717.117zM2.321 8.318c0-.426.27-.803.672-.937L17.69 2.445a.976.976 0 01.622 0l14.696 4.936a.99.99 0 01.672.94v15.65c0 1.499-.618 3.012-1.792 4.538-1.176 1.532-2.828 2.965-4.665 4.247-3.359 2.346-7.09 4.005-8.884 4.74a.948.948 0 01-.721 0c-1.789-.736-5.48-2.394-8.839-4.74-1.836-1.282-3.488-2.715-4.665-4.247-1.173-1.527-1.792-3.04-1.792-4.538V8.318z",
  fill: "#B5BFCD"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 34.872c0 .328.33.551.63.423.251-.108.528-.23.826-.364 1.475-.664 3.42-1.63 5.346-2.84 1.944-1.223 3.756-2.626 5.056-4.136 1.303-1.515 1.908-2.919 1.908-4.214V10.097c0-.597-.38-1.127-.941-1.316L18.603 4.677a.46.46 0 00-.604.439v29.756z",
  fill: "#B5BFCD"
});

var SvgQuarantee = function SvgQuarantee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgQuarantee;